import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import {
  Shield,
  Users,
  BadgeCheck,
  TrendingUp,
  HeartHandshake,
  BarChart3,
} from "lucide-react";
import Register from "@/components/home/register";

const About = () => {
    return (
        <>
            <section className="bg-pink-900 py-20 px-4">
                <div className="max-w-7xl mx-auto text-center text-white">
                    <h1 className="text-4xl md:text-5xl font-heading font-bold mb-6">
                        About Axent Brokers
                    </h1>
                    <p className="text-xl max-w-3xl mx-auto">
                        Your trusted partner for comprehensive insurance solutions since
                        2016.
                    </p>
                </div>
            </section>

            <section className="py-16 px-4">
                <div className="max-w-7xl mx-auto">
                    <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
                        <div>
                            <h2 className="text-3xl font-heading font-semibold text-neutral-800 mb-6">
                                Our Story
                            </h2>
                            <p className="text-lg mb-6">
                                We offer a specialist commercial underwriting service to Insurance Intermediaries and Brokers,
                                our expertise coupled with what we believe to be the most up to date internet quotation system
                                obtainable for the property owners and commerical sectors we underwrite.
                            </p>
                            <p className="text-lg mb-6">
                                Our concept is to provide a quick, simple and the most user friendly platform available,
                                to allow you not only to obtain quotations but to issue immediate cover together with
                                full policy documentation on behalf of your clients.
                                We are authorised to underwrite and issue policy documentation on behalf of our insurance partners.
                            </p>
                            <p className="text-lg mb-6">
                                Insurance can sometimes be very complex our aim is to use the most up to date technology
                                to achieve fast, accurate and extremely competitive quotations on behalf of your clients
                                by providing you with the means to deliver our products. We believe that customer focus
                                is very important this together with being industry compliant will not only make placing
                                business with Axent secure and trouble-free but we are certain a very confident move for your clients.
                            </p>
                            <p className="text-lg mb-6">
                                Today, we maintain that same client-first approach while
                                leveraging modern technology and partnerships with leading
                                insurance providers to offer the best coverage options at
                                competitive rates.
                            </p>
                        </div>
                        <div className="mt-10 lg:mt-0">
                            <div
                                className="rounded-lg shadow-lg h-80 bg-cover bg-center"
                                style={{
                                    backgroundImage:
                                        "url('https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80')",
                                }}
                                role="img"
                                aria-label="Office of Axent Brokers"
                            ></div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-16 px-4 bg-sky-100">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl font-heading font-semibold text-neutral-800 mb-4">
                            Our Core Values
                        </h2>
                        <p className="text-lg text-neutral-800 max-w-3xl mx-auto">
                            These principles guide everything we do and define how we serve
                            our clients.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div className="bg-white p-8 rounded-lg shadow-md">
                            <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-6">
                                <Shield className="h-6 w-6 text-primary" />
                            </div>
                            <h3 className="text-xl font-heading font-semibold mb-4">
                                Client Protection
                            </h3>
                            <p>
                                We prioritize finding the right coverage to protect your clients'
                                assets, health, and future, not just selling policies.
                            </p>
                        </div>

                        <div className="bg-white p-8 rounded-lg shadow-md">
                            <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-6">
                                <Users className="h-6 w-6 text-primary" />
                            </div>
                            <h3 className="text-xl font-heading font-semibold mb-4">
                                Personal Relationships
                            </h3>
                            <p>
                                We build lasting relationships with our clients, taking the time
                                to understand their unique situations and needs.
                            </p>
                        </div>

                        <div className="bg-white p-8 rounded-lg shadow-md">
                            <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-6">
                                <BadgeCheck className="h-6 w-6 text-primary" />
                            </div>
                            <h3 className="text-xl font-heading font-semibold mb-4">
                                Integrity
                            </h3>
                            <p>
                                We operate with honesty and transparency in all our dealings,
                                providing clear information and recommendations.
                            </p>
                        </div>

                        <div className="bg-white p-8 rounded-lg shadow-md">
                            <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-6">
                                <TrendingUp className="h-6 w-6 text-primary" />
                            </div>
                            <h3 className="text-xl font-heading font-semibold mb-4">
                                Continuous Improvement
                            </h3>
                            <p>
                                We constantly seek better ways to serve our clients through
                                education, technology, and expanded offerings.
                            </p>
                        </div>

                        <div className="bg-white p-8 rounded-lg shadow-md">
                            <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-6">
                                <HeartHandshake className="h-6 w-6 text-primary" />
                            </div>
                            <h3 className="text-xl font-heading font-semibold mb-4">
                                Community Involvement
                            </h3>
                            <p>
                                We actively participate in and support the communities we serve
                                through volunteering and charitable initiatives.
                            </p>
                        </div>

                        <div className="bg-white p-8 rounded-lg shadow-md">
                            <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-6">
                                <BarChart3 className="h-6 w-6 text-primary" />
                            </div>
                            <h3 className="text-xl font-heading font-semibold mb-4">
                                Value-Driven Results
                            </h3>
                            <p>
                                We measure success by client satisfaction and the value of
                                protection we provide, not just by policies sold.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-16 px-4">
                <div className="max-w-7xl mx-auto">
                    <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
                        <div className="order-2 lg:order-1 mt-10 lg:mt-0">
                            <div
                                className="rounded-lg shadow-lg h-80 bg-cover bg-center"
                                style={{
                                    backgroundImage:
                                        "url('https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80')",
                                }}
                                role="img"
                                aria-label="Axent Brokers team meeting"
                            ></div>
                        </div>
                        <div className="order-1 lg:order-2">
                            <h2 className="text-3xl font-heading font-semibold text-neutral-800 mb-6">
                                Why Choose Axent Brokers?
                            </h2>
                            <ul className="space-y-4">
                                <li className="flex">
                                    <div className="h-6 w-6 rounded-full bg-primary/10 flex items-center justify-center mt-1 mr-3 flex-shrink-0">
                                        <span className="text-primary text-sm font-bold">1</span>
                                    </div>
                                    <p className="text-lg">
                                        <span className="font-semibold">Independence:</span> As an
                                        independent broker, we work for you, not the insurance
                                        companies. This means we can offer unbiased recommendations
                                        and shop multiple carriers to find the best coverage and
                                        rates.
                                    </p>
                                </li>
                                <li className="flex">
                                    <div className="h-6 w-6 rounded-full bg-primary/10 flex items-center justify-center mt-1 mr-3 flex-shrink-0">
                                        <span className="text-primary text-sm font-bold">2</span>
                                    </div>
                                    <p className="text-lg">
                                        <span className="font-semibold">Expertise:</span> Our team
                                        includes specialists in various insurance areas, ensuring
                                        you receive knowledgeable guidance for all your coverage
                                        needs.
                                    </p>
                                </li>
                                <li className="flex">
                                    <div className="h-6 w-6 rounded-full bg-primary/10 flex items-center justify-center mt-1 mr-3 flex-shrink-0">
                                        <span className="text-primary text-sm font-bold">3</span>
                                    </div>
                                    <p className="text-lg">
                                        <span className="font-semibold">Personalised Service:</span>{" "}
                                        We take the time to understand your unique situation and
                                        tailor recommendations to your specific needs and budget.
                                    </p>
                                </li>
                                <li className="flex">
                                    <div className="h-6 w-6 rounded-full bg-primary/10 flex items-center justify-center mt-1 mr-3 flex-shrink-0">
                                        <span className="text-primary text-sm font-bold">4</span>
                                    </div>
                                    <p className="text-lg">
                                        <span className="font-semibold">Ongoing Support:</span> Our
                                        relationship doesn't end when your client purchases a policy. We
                                        provide continued service, review the coverage regularly,
                                        and assist with claims when needed.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <Register />
        </>
    );
};

export default About;
